/**
 * Resolves the positional selection (`CellCoord[]`) into the row + column
 * identity consumers act on (`SelectedCell[]`). Mirrors the coord→data mapping
 * in serializeSelectionToTsv, but carries identity + row only — no DOM node or
 * resolved value.
 *
 * Coords whose row or column is out of range (e.g. after the data changed) are
 * skipped. Order follows the input `coords`.
 */
export const getSelectedCells = (coords, columns, rows, getRowId) => {
  const cells = [];
  coords.forEach(({
    rowIndex,
    columnIndex
  }) => {
    const row = rows[rowIndex];
    const column = columns[columnIndex];
    if (row === undefined || column === undefined) return;
    cells.push({
      row,
      rowId: getRowId(row),
      columnName: column.columnName,
      columnNamespace: column.columnNamespace,
      rowIndex,
      columnIndex
    });
  });
  return cells;
};